<div class="base-layout">
  <app-navbar></app-navbar>
  <div class="main-content container-fluid" id="main-content">
    <router-outlet></router-outlet>
  </div>
</div>
